import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src3013983402/src/src/templates/markdown-page.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>Terms and conditions applicable to all .cn registrations:</h1>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>
    <p>
  <strong>1. REPRESENTATIONS AND WARRANTIES.</strong> You represent and certify
  that, to the best of your knowledge and belief, (i) neither the registration
  of the domain name nor the manner in which it is directly or indirectly used
  infringes the legal rights of any third party, (ii) you have the requisite
  power and authority to enter into this Agreement and to perform the
  obligations hereunder, (iii) you are of legal age to enter into this
  Agreement, and (vi) you agree to comply with all applicable laws, regulations
  and policies of the Peoples Republic of China’s governmental agencies and the
  China Internet Network Information Center (“CNNIC”), including but not limited
  to the following rules and regulations: (i) China Internet Domain Name
  Regulations (currently at{' '}
  <a href="http://www.cnnic.net.cn/ruler/20.shtml">
    http://www.cnnic.net.cn/ruler/20.shtml
  </a>
  ); (ii) CNNIC Detailed Rules of Internet Domain Name Registration
  Administration (currently at{' '}
  <a href="http://www.cnnic.net.cn/ruler/16.shtml">
    http://www.cnnic.net.cn/ruler/16.shtml
  </a>
  ); (iii) CNNIC Domain Name Dispute Resolution Policy (currently at{' '}
  <a href="http://www.cnnic.net.cn/doc/e-10.shtml">
    http://www.cnnic.net.cn/doc/e-10.shtml
  </a>
  ); and (iv) Rules for CNNIC Domain Name Dispute Resolution Policy (currently
  at{' '}
  <a href="http://www.cnnic.net.cn/doc/e-9.shtml">
    http://www.cnnic.net.cn/doc/e-9.shtml
  </a>
  ).{' '}
    </p>
    <p>
  <strong>2. PROVISION OF REGISTRATION DATA.</strong> As part of the
  registration process, you are required to provide us with certain information
  and to update this information to keep it current, complete and accurate. This
  information includes: (i) the Registered Name; (ii) the names of the primary
  nameserver and secondary nameserver(s) for the Registered Name; (iii) your
  name, postal address, e-mail address, voice telephone number and (where
  available) fax number; (iv) the name, postal address, e-mail address, voice
  telephone number, and (where available) fax number of the technical contact
  for the Registered Name; (v) the name, postal address, e-mail address, voice
  telephone number, and (where available) fax number of the administrative
  contact for the Registered Name; (vi) the name, postal address, e-mail
  address, voice telephone number, and fax number if available of the billing
  contact for the Registered Name; (vii) any remark concerning the registered
  domain name that should appear in the Whois directory; and (viii) any other
  data CNNIC, as the Registry, requires be submitted to it. You agree and
  understand that the foregoing registration data will be publicly available and
  accessible on the Whois directory pursuant to the CNNC Policy. Any information
  collected by us concerning an identified or identifiable natural person
  ("Personal Data") will be used in connection with the registration of your
  domain name(s) and for the purposes of this Agreement and as required or
  permitted by the CNNIC.{' '}
    </p>
    <p>
  <strong>3. BUSINESS OR ORGANIZATION REPRESENTATION.</strong> The .cn top-level
  domain space is intended for businesses and organizations and not for
  individual use. By registering a .cn domain name, you hereby represent that
  you have registered the domain name on behalf of a business or
  organization.{' '}
    </p>
    <p>
  <strong>4. INACCURATE OR UNRELIABLE DATA.</strong> You hereby represent and
  warrant that the data provided in the domain name registration application is
  true, correct, up to date and complete and that you will continue to keep all
  the information provided up to date. Your willful provision of inaccurate or
  unreliable information, your willful failure promptly to update information
  provided to us, or any failure to respond for over five calendar days to our
  inquiries addressed to the e-mail address of the administrative, billing or
  technical contact then appearing in the Whois directory with respect to a
  domain name concerning the accuracy of contact details associated with any
  registration(s) or the registration of any domain name(s) registered by or
  through you or your account, shall constitute a breach of this Agreement.{' '}
    </p>
    <p>
  <strong>5. MAXIMUM TERM.</strong> The maximum term for a domain name
  registration in the .cn TLD shall be five (5) years. Domain Name Registrations
  shall be available for terms of one, two, three, four and five years.{' '}
    </p>
    <p>
  <strong>6. PROHIBITED USES FOR .CN DOMAIN NAME.</strong> Registrant may not
  register or use a domain name that is deemed by CNNIC to:{' '}
    </p>
    <blockquote>
  <p>
    (i) Be against the basic principles prescribed in the Constitution of the
    Peoples Republic of China (“PRC”);
  </p>
  <p>
    (ii) Jeopardize national security, leak state secrets, intend to overturn
    the government, or disrupt of state integrity of the PRC;
  </p>
  <p>(iii) Harm national honor and national interests of the PRC;</p>
  <p>
    (iv) Instigate hostility or discrimination between different nationalities,
    or disrupt the national solidarity of the PRC;
  </p>
  <p>
    (v) Violate the PRC’s religion policies or propagate cult and feudal
    superstition;
  </p>
  <p>
    (vi) Spread rumors, disturb public order or disrupt social stability of the
    PRC;
  </p>
  <p>
    (vii) Spread pornography, obscenity, gambling, violence, homicide, terror or
    instigate crimes in the PRC;
  </p>
  <p>
    (viii) Insult, libel against others and infringe other people's legal rights
    and interests in the PRC; or
  </p>
  <p>
    (ix) Take any other action prohibited in laws, rules and administrative
    regulations of the PRC.
  </p>
    </blockquote>
    <p>
  <strong>7. TRUE REGISTRANT OF DOMAIN NAME.</strong> By registering a .cn
  domain name, you shall be the registrant of record and responsible for
  providing full contact information and for providing and updating accurate
  technical and administrative contact information adequate to facilitate timely
  resolution of any problems that arise in connection with the domain name. You
  accept liability for harm caused by wrongful use of the domain name.{' '}
    </p>
    <p>
  <strong>8. DOMAIN NAME DISPUTE POLICY.</strong> If you have registered a
  second or third-level .cn domain name through us, you agree to be bound by the
  CNNIC Domain Name Dispute Resolution Policy &amp; Rules for CNNIC Domain Name
  Dispute Resolution Policy (“Dispute Policy”),
  http://www.cnnic.net.cn/ruler/20.shtml, which is incorporated herein and made
  a part of this Agreement by reference. Please take the time to familiarize
  yourself with that policy. In addition, you hereby acknowledge that you have
  read and understood and agree to be bound by the terms and conditions of the
  policies of the CNNIC, as they may be amended from time to time, and which are
  hereby incorporated and made an integral part of this Agreement.{' '}
    </p>
    <p>
  <strong>9. DOMAIN NAME DISPUTES POLICY MODIFICATIONS.</strong> You agree that
  we, in our sole discretion, may modify our dispute policy. We will post any
  such revised policy on our Web site at least thirty (30) calendar days before
  it becomes effective. You agree that, by maintaining the registration of your
  domain name after modifications to the dispute policy become effective, you
  have agreed to these modifications. You acknowledge that if you do not agree
  to any such modification, you may terminate this Agreement. We will not refund
  any fees paid by you if you terminate your Agreement with us.{' '}
    </p>
    <p>
  <strong>10. DOMAIN NAME DISPUTES.</strong> You agree that, if your use of our
  domain name registration services is challenged by a third party, you will be
  subject to the provisions specified in the Dispute Policy in effect at the
  time of the dispute. You agree that in the event a domain name dispute arises
  with any third party, you will indemnify and hold us, CNNIC and NeuStar,
  Inc.(“Registry Gateway Provider”), harmless pursuant to the terms and
  conditions set forth in this Agreement. If we are notified that a complaint
  has been filed with a judicial or administrative body regarding your use of
  our domain name registration services, you agree not to make any changes to
  your domain name record without our prior approval. We may not allow you to
  make changes to such domain name record until (i) we are directed to do so by
  the judicial or administrative body, or (ii) we receive notification by you
  and the other party contesting your registration and use of our domain name
  registration services that the dispute has been settled. Furthermore, you
  agree that if you are subject to litigation regarding your registration and
  use of our domain name registration services, we may deposit control of your
  domain name record into the registry of the judicial body by supplying a party
  with a registrar certificate from us.{' '}
    </p>
    <p>
  <strong>11. JURISDICTION.</strong> For the adjudication of disputes concerning
  or arising from use of the Registered Name, the Registrant shall submit,
  without prejudice to other potentially applicable jurisdictions, to the
  jurisdiction of the courts (1) of the Registrant's domicile, (2) where
  Registrar is located, and 3) the People’s Republic of China.{' '}
    </p>
    <p>
  <strong>12. GOVERNING LAW.</strong> For the adjudication of a dispute
  concerning or arising from use of the domain name, such dispute shall be
  governed under the Laws of the Peoples Republic of China.{' '}
    </p>
    <p>
  <strong>13. SUSPENSION, CANCELLATION OR TRANSFER.</strong> You agree that your
  registration of the domain name shall be subject to suspension, cancellation,
  or transfer pursuant to any CNNIC adopted specification or policy, or pursuant
  to any registrar or CNNIC procedure not inconsistent with a CNNIC adopted
  specification or policy, (1) to correct mistakes by Registrar or the CNNIC in
  registering the name or (2) for the resolution of disputes concerning the
  domain name.{' '}
    </p>
    <p>
  <strong>14. INDEMNIFICATION.</strong> The Registrant shall indemnify and hold
  harmless the Registrar, Registry Gateway Provider and CNNIC and their
  directors, officers, employees, representatives, agents, affiliates, and
  stockholders from and against any and all claims, suits, actions, other
  proceedings, damages, liabilities, costs and expenses of any kind, including
  without limitation reasonable legal fees and expenses, arising out of or
  relating to the Registrant’s (i) domain name registration and (ii) use of any
  of a domain name.{' '}
    </p>
    <p>
  Reservation by CNNIC and Registry Gateway Provider. Registrar, the Registry
  Gateway Provider and CNNIC reserve the right to deny, cancel or transfer any
  registration that they deem necessary, in their discretion, (1) to protect the
  integrity and stability of the registry, (2) to comply with any applicable
  laws, government rules or requirements, requests of law enforcement, in
  compliance with any dispute resolution process, (3) to avoid any liability,
  civil or criminal, on the part of CNNIC, the Registry Gateway Provider or
  Registrar, as well as their affiliates, subsidiaries, officers, directors,
  representatives, employees, and stockholders, (4) for violations of this
  Agreement, or (5) to correct mistakes made by Registry Gateway Provider, CNNIC
  or any registrar in connection with a domain name registration. CNNIC,
  Registry Gateway Provider and Registrar also reserve the right to freeze a
  domain name during resolution of a dispute.{' '}
    </p>
    <p>
  <a href="/terms-conditions">Back to Terms and Conditions</a>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      